<script>
import { mapState } from "vuex";

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Snackbar from "@/components/_Shared/Snackbar";
import Preloader from "@/components/_Shared/Preloader";

export default {
  components: {
    Navbar,
    Sidebar,
    Snackbar
  },
  computed: {
    ...mapState("sidebar", ["opened"])
  },
  mounted() {
    this.$cable._cable.url = `${process.env.WEBSOCKET_URL}?token=${localStorage.authentication}`;
  }
};
</script>

<template>
  <div class="wrapper">
    <snackbar />
    <Sidebar />

    <div class="content-wrapper" :class="{ 'sidebar-closed': !opened }">
      <Navbar />

      <keep-alive>
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </keep-alive>
    </div>
  </div>
</template>

<style scoped>
.content-wrapper {
  position: relative;
  width: calc(100% - 260px);
  min-height: calc(100vh - 60px);
  background-color: #f2f2f2;
  padding: 0 30px;
  transition: all 0.24s ease;
}

.sidebar-closed {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Wrapper.vue